<template>
  <v-form
    ref="formStepStoreInternalInformation"
    v-model="formStepStoreInternalInformationValid"
    @submit.prevent="submit"
  >
    <v-card class="rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
      <v-row>
        <v-col class="pb-0">
          <h1>{{ $t('FILE_STEP_STORE_INTERNAL.TITLE') }}</h1>
        </v-col>
      </v-row>

      <!-- Internal command number -->
      <v-row md="12">
        <v-col>
          <p data-mandatory="true" class="content-title">
            {{ $t('FILE_STEP_STORE_INTERNAL.FORM.INTERNAL_COMMAND_NUMBER') }}
          </p>
          <v-text-field
            v-model="internalCommandNumber"
            :disabled="currentRepairFile.with_erp_intern"
            @input="filterInput"
            :error-messages="error?.internal_command_number"
            required
            :rules="[...requiredRules, ...max11CharRules]"
            :maxlength="11"
            :counter="11"
            hide-details="auto"
          />
          <p class="custom-hint">
            {{ $t('FILE_STEP_STORE_INTERNAL.FORM.INTERNAL_COMMAND_NUMBER_HINT') }}
          </p>
        </v-col>
      </v-row>
    </v-card>

    <v-btn
      :disabled="!formStepStoreInternalInformationValid || loading"
      :loading="loading"
      class="boom-button mt-4 pl-15 pr-15"
      variant="outlined"
      type="submit"
    >
      {{ $t('COMMON.BUTTON.CONTINUE') }}
      <img
        alt="arrow_small-icon"
        class="arrow-svg"
        src="@/assets/icons/file/arrow_small_right.svg"
      />
    </v-btn>
  </v-form>
</template>

<script>
import RepairFileService from '@/services/RepairFileService'
import ResponseConstant from '@/constants/responseConstant'
import { auth as $store } from '@/store/AuthModule'
import { RepairFile } from '@/models/RepairFile'
import Validator from '@/components/utils/validator'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'

export default {
  name: 'StepStoreInternInformation',
  props: {
    currentRepairFile: RepairFile,
    currentStep: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formStepStoreInternalInformationValid: false,
      loading: false,
      internalCommandNumber: null,

      requiredRules: Validator.requiredRules,
      max11CharRules: Validator.max11CharRules,

      error: null
    }
  },
  async created() {
    try {
      this.internalCommandNumber = this.currentRepairFile.internal_command_number
    } catch (error) {
      displayToast(this.$t(
          'ERROR_STATUS_CODE_MESSAGE.' + (error.response ? error.response.status : 'UNKNOWN')
        ), 'error')
    }
  },
  methods: {
    submit() {
      let data = {
        status_detail: RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED,
        is_complete_update: 'True',
        requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
        internal_command_number: this.internalCommandNumber
      }
      const formData = new FormData()
      formData.append('data', JSON.stringify(data))
      this.updateStep(formData, false)
    },
    async updatePartialData() {
      let data = {
        status_detail: RepairFileStatusDetailConstant.INTERNAL_COMMAND_NUMBER_LINKED,
        requestor_collaborator_id: this.getCurrentCollaborator().technical_id,
        internal_command_number: this.internalCommandNumber
      }
      const formData = new FormData()
      formData.append('data', JSON.stringify(data))
      await this.updateStep(formData, true)
    },
    async updateStep(formData, isPartial = false) {
      this.loading = true
      const repairFileId = this.currentRepairFile.technical_id
      try {
        await RepairFileService.update(repairFileId, formData)
        if (isPartial === false) {
          this.$emit('change-step', this.currentStep + 1)
        }
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
      } finally {
        this.loading = false
      }
    },
    getCurrentCollaborator() {
      return $store.state.currentCollaborator
    },
    filterInput(event) {
      const forbiddenChars = /[!@#$%^&*(),.?":{}|<>/\s]/g
      this.internalCommandNumber = event.target.value.replace(forbiddenChars, '').toUpperCase()
    }
  }
}
</script>

<style scoped>
.v-card {
  padding: 40px !important;
}

.content-title {
  margin-bottom: 10px;
}

.arrow-svg {
  filter: invert(89%) sepia(98%) saturate(1%) hue-rotate(266deg) brightness(110%) contrast(97%);
}
</style>
